import AnimateOnScroll from './AnimateOnScroll';

const logos = [
  { name: 'HSBC', src: 'https://www.envizage.me/wp-content/uploads/2024/12/hsbc.png' },
  { name: 'Aviva', src: 'https://www.envizage.me/wp-content/uploads/2025/05/aviva.png' },
  { name: 'Mercer', src: 'https://www.envizage.me/wp-content/uploads/2025/05/mercer.png' },
  { name: 'Allianz', src: 'https://www.envizage.me/wp-content/uploads/2024/12/allianz.png' },
  { name: 'AMP', src: 'https://www.envizage.me/wp-content/uploads/2025/05/amp.png' },
  { name: 'APG', src: 'https://www.envizage.me/wp-content/uploads/2024/12/apg.png' },
  { name: 'AXA', src: 'https://www.envizage.me/wp-content/uploads/2024/12/axa.png' },
  // { name: 'BCG Digital Ventures', src: 'https://www.envizage.me/wp-content/uploads/2024/12/BCG-Digital-Ventures.png' },
  { name: 'Barclays', src: 'https://www.envizage.me/wp-content/uploads/2024/12/Barclays.png' },
  { name: 'BNP Paribas', src: 'https://www.envizage.me/wp-content/uploads/2024/12/bnp-paribas.png' },
  { name: 'Cahoot', src: 'https://www.envizage.me/wp-content/uploads/2024/12/Cahoot.png' },
  { name: 'Coutts', src: 'https://www.envizage.me/wp-content/uploads/2025/05/coutts.png' },
  { name: 'Lloyds', src: 'https://www.envizage.me/wp-content/uploads/2024/12/lloyds.png' },
  { name: 'MassMutual', src: 'https://www.envizage.me/wp-content/uploads/2024/12/mass-mutual.png' },
  { name: 'Moneyfarm', src: 'https://www.envizage.me/wp-content/uploads/2024/12/moneyfarm.png' },
  { name: 'Morgan Stanley', src: 'https://www.envizage.me/wp-content/uploads/2024/12/morgan-stanley.png' },
  { name: 'NatWest', src: 'https://www.envizage.me/wp-content/uploads/2024/12/Natwest.png' },
  { name: 'Phoenix', src: 'https://www.envizage.me/wp-content/uploads/2024/12/phoenix.png' },
  { name: 'SPW', src: 'https://www.envizage.me/wp-content/uploads/2024/12/spw-dark.png' },
  { name: 'Smart Pension', src: 'https://www.envizage.me/wp-content/uploads/2024/12/smartpension.png' },
  { name: 'AOLP', src: 'https://www.envizage.me/wp-content/uploads/2025/05/AOLP.png' },
];

export default function AboutSection() {
  const scrollToRegister = () => {
    const el = document.querySelector('#register');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="about" className="bg-white py-24 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">

        {/* About text */}
        <div className="max-w-3xl mx-auto text-center mb-20">
          <AnimateOnScroll variant="fade-up">
            <p className="text-xs font-bold tracking-widest text-brown-300 uppercase mb-4">About Envizage</p>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1a1a2e] leading-tight mb-6">
              Built by Financial Planning Experts. Powered by a World-Class API.
            </h2>
            <p className="text-base text-[#5a5a6a] leading-relaxed mb-5">
              Envizage was founded in 2014 by a team of financial planning veterans and technologists. Envizage.AI was born from a single frustration: brilliant planners were spending hours on data gathering and modelling that computers should handle — and generic AI tools were misleading customers.
            </p>
            <p className="text-base text-[#5a5a6a] leading-relaxed">
              We set out to build something different. A platform that pairs the conversational accessibility of modern AI with the rigour of CFP-grade planning logic — so planners can focus on what they're actually great at: giving advice.
            </p>
          </AnimateOnScroll>
        </div>

        {/* Institutional Pedigree + logo marquee */}
        <AnimateOnScroll variant="fade-up">
          <p className="text-center text-xs font-bold tracking-widest text-[#9a9aaa] uppercase mb-10">
            <strong className="text-brown-300">Institutional Pedigree:</strong>&nbsp; The Envizage engine trusted by leading global financial institutions now powers Envizage.ai
          </p>
        </AnimateOnScroll>

        <AnimateOnScroll variant="fade-up" delay={100}>
          <div className="relative mb-16 overflow-hidden">
            <div className="absolute inset-y-0 left-0 w-10 sm:w-24 bg-gradient-to-r from-white to-transparent pointer-events-none z-10"></div>
            <div className="absolute inset-y-0 right-0 w-10 sm:w-24 bg-gradient-to-l from-white to-transparent pointer-events-none z-10"></div>
            <div className="flex" style={{ animation: 'marquee 40s linear infinite' }}>
              {[...logos, ...logos].map((l, i) => (
                <div key={`${l.name}-${i}`} className="flex-shrink-0 flex items-center justify-center px-5 sm:px-8">
                  <img
                    src={l.src}
                    alt={l.name}
                    className="h-6 sm:h-7 w-auto object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </AnimateOnScroll>

        {/* Learn more CTA */}
        <AnimateOnScroll variant="fade-up" delay={150}>
          <div className="text-center">
            <a
              href="https://www.envizage.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-brown-300 hover:text-[#1a1a2e] transition-colors"
            >
              Learn more about us <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </AnimateOnScroll>

        {/* Founder quote */}
        {/* <AnimateOnScroll variant="zoom-in" delay={100}>
          <div className="bg-[#222] rounded p-8 lg:p-12 text-center relative overflow-hidden">
            <div className="relative z-10">
              <div className="w-10 h-10 flex items-center justify-center rounded bg-white/10 mx-auto mb-5">
                <i className="ri-double-quotes-l text-xl text-white"></i>
              </div>
              <blockquote className="text-lg lg:text-xl font-medium text-white leading-relaxed max-w-3xl mx-auto mb-6 italic">
                "We built Envizage.AI because the best financial advice in the world is worthless if planners are too buried in admin to deliver it. Our job is to take the grind away — so the human expertise can finally shine through."
              </blockquote>
              <div className="flex items-center justify-center gap-3">
                <img
                  alt="Vinay Jayaram"
                  className="w-10 h-10 rounded object-cover object-top border-2 border-white/20"
                  src="https://www.envizage.me/wp-content/uploads/2022/01/DSCF7921@2x-1.png"
                />
                <div className="text-left">
                  <p className="text-md font-semibold text-white">Vinay Jayaram</p>
                  <p className="text-xs text-white/60">Co-Founder &amp; CEO, Envizage</p>
                </div>
              </div>
            </div>
          </div>
        </AnimateOnScroll> */}

      </div>
    </section>
  );
}
